import { render, staticRenderFns } from "./VeJwKaoshiModal.vue?vue&type=template&id=a15fb2da"
import script from "./VeJwKaoshiModal.vue?vue&type=script&lang=js"
export * from "./VeJwKaoshiModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports